import {tags} from "../../api";

export default {
    state: {
        all: []
    },

    actions: {
        fetchTags(context) {
            let token = context.getters.getToken.jwt;

            return tags({token})
                .then(r => context.commit("setAllTags", r.data));
        }
    },

    mutations: {
        setAllTags(state, payload) {
            console.log("setTags", payload);
            state.all = payload;
        }
    },

    getters: {}
}